import { render, staticRenderFns } from "./MailingSchedule.vue?vue&type=template&id=c54f1f7c&scoped=true&"
import script from "./MailingSchedule.vue?vue&type=script&lang=js&"
export * from "./MailingSchedule.vue?vue&type=script&lang=js&"
import style0 from "./MailingSchedule.vue?vue&type=style&index=0&id=c54f1f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54f1f7c",
  null
  
)

export default component.exports